import { Control, Controller, RegisterOptions } from 'react-hook-form'

import { Select, SelectIProps, SelectOption } from '@hivewatch/dark'

export interface ControlledSelectIProps
  extends Omit<SelectIProps, 'value' | 'onChange'> {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  control: Control<any>
  name: string
  rules?: RegisterOptions
  defaultValue?: SelectOption | null
}

/**
 * Binds the dark `Select` to react-hook-form via `Controller`. The field stores
 * the full `SelectOption`. Keeps the dark package form-library-agnostic — the
 * RHF glue lives here, once.
 */
export const ControlledSelect = ({
  control,
  name,
  rules,
  defaultValue = null,
  ...rest
}: ControlledSelectIProps) => (
  <Controller
    control={control}
    defaultValue={defaultValue}
    name={name}
    render={({ value, onChange }) => (
      <Select {...rest} onChange={onChange} value={value ?? null} />
    )}
    rules={rules}
  />
)
